// extracted by mini-css-extract-plugin
export default {"carousel-dots":"carousel-dots_carousel-dots__7q5c5","dot":"carousel-dots_dot__Ms5pw","dot--active":"carousel-dots_dot--active__+wPvi"};